import React from 'react';
import { useSelector } from 'react-redux';

import { TransactionedOverExistingRealties } from './transactionedOverExistingRealties';

export const TransactionsCharts: React.FC = () => {
  const { isGridView } = useSelector((state: any) => state.chartsState);
  return (
    <div className="realty-transactions-charts">
      <div
        className={`two-charts-container ${
          isGridView ? 'grid-layout' : 'list-layout'
        } `}
      >
        <TransactionedOverExistingRealties />
      </div>
    </div>
  );
};
